import TungSVG_Ok from "./gsap/TungSVG_Ok";
// import Trang_v1 from "./gsap/Trang_v1";
// import Trang_v2 from "./gsap/Trang_v2";
// import Trang_v3 from "./gsap/Trang_v3";
// import Trang_v4 from "./gsap/Trang_v4";
import Trang_v5 from "./gsap/Trang_v5";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Link to="/"></Link>
        {/* <Link to="/paA1"></Link>
        <Link to="/paA2"></Link> */}
        <Link to="/phienkhaimac"></Link>
        <Link to="/phienhop"></Link>
        <Link to="/dhtt"></Link>
        <Routes>
          {/* <Route path="/" element={<TungSVG_Ok wkSheet={0} nameEvent={"Phiên khai mạc"} datetimeEvent={'Sáng 8/6/2026 (106 VIP)'}/>}/> */}
          {/* <Route path="/paA1" element={<TungSVG_Ok wkSheet={0} nameEvent={"Phiên khai mạc"} datetimeEvent={'Sáng 8/6/2026 (106 VIP)'}/>}/> */}
          {/* <Route path="/paA2" element={<TungSVG_Ok wkSheet={1} nameEvent={"Phiên khai mạc"} datetimeEvent={'Sáng 8/6/2026 (118 VIP)'}/>}/> */}
          <Route path="/" element={<TungSVG_Ok wkSheet={0} nameEvent={"Phiên khai mạc"} datetimeEvent={'Sáng 8/6/2026 (100 khách VIP)'}/>}/>
          <Route path="/phienkhaimac" element={<TungSVG_Ok wkSheet={0} nameEvent={"Phiên khai mạc"} datetimeEvent={'Sáng 8/6/2026 (100 khách VIP)'}/>}/>
          <Route path="/phienhop" element={<TungSVG_Ok wkSheet={1} nameEvent={"Phiên Trù bị, họp thường, bế mạc"} datetimeEvent={'Ngày 7/6, chiều 8/6/2026'}/>}/>
          {/* <Route path="/dh8" element={<TungSVG_Ok wkSheet={0}/>}/>
          <Route path="/pa01" element={<Trang_v1 wkSheet={1}/>}/>
          <Route path="/pa02" element={<Trang_v2 wkSheet={2}/>}/>
          <Route path="/pa03" element={<Trang_v3 wkSheet={3}/>}/>
          <Route path="/pa04" element={<Trang_v3 wkSheet={4}/>}/>
          <Route path="/pa05" element={<Trang_v3 wkSheet={5}/>}/>
          <Route path="/pa06" element={<Trang_v4 wkSheet={6}/>}/>*/}
          <Route path="/dhtt" element={<Trang_v5 wkSheet={6}/>}/> 
          {/* báo cáo Mr. Định & đã chốt */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;